import Vue from "vue";
import { newLogger } from "@/utils/util";
import network from "../../../utils/network";

let logger = newLogger("CustomerStore");

const urls = {
  customerWithId: (id) => `/customer/${id}`,
};

/**
 * Customer store
 */

const initState = () => {
  return {
    customerList: { values: [], total: 0 },
    data: {}, // map individual DTOs by ID
    loginHistories: {},
  };
};

const actions = {
  fetchOne: async ({ commit }, id) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.customerWithId(id));
      commit("saveOne", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  saveOne: (state, data) => {
    Vue.set(state.data, data.id, data);
  },
};

const getters = {
  get: (state) => (id) => {
    return state.data[id];
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
